import { Client } from "@seneca/client-library";
import { FetchXpResponse, UserXpRewardsI } from "@seneca/xp-service-types";

export default class XpServiceClient extends Client {
  async fetchXP({
    courseId,
    quizId
  }: { courseId?: string; quizId?: string } = {}) {
    const url = `${this.url}/api/xp/me?date="${new Date().toISOString()}"${
      courseId ? `&courseId="${courseId}"` : ""
    }${quizId ? `&quizId="${quizId}"` : ""}`;

    const response = await this.requestMaker.makeRequest(url, {
      method: "GET"
    });

    return response.json as FetchXpResponse;
  }

  async fetchRewards() {
    const url = `${this.url}/api/xp-rewards/me`;

    const response = await this.requestMaker.makeRequest(url, {
      method: "GET"
    });

    return response.json as UserXpRewardsI;
  }
}
